
import { call, put, takeEvery } from "redux-saga/effects";
import { hinhThucThiApi } from "../../../api/tct/hinhThucThiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IHinhThucThi } from "../../../model/respone/tct/IHinhThucThi";
import { eHinhThucThiActionIds, IHinhThucThiActionTypes } from "../../action-types/tct/IHinhThucThiActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
const mainAction = rootActions.toChucThi.hinhThucThi;
export function* hinhThucThiSaga(): any {
    yield takeEvery(eHinhThucThiActionIds.LOAD_START, loadWorker)
    yield takeEvery(eHinhThucThiActionIds.SAVE_START, saveWorker)
    yield takeEvery(eHinhThucThiActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IHinhThucThiActionTypes): any {
    const res: IBaseRespone = yield call(hinhThucThiApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IHinhThucThiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IHinhThucThi
    if (payload.id_hinh_thuc > 0) {
        res = yield call(hinhThucThiApi.Update, payload)
    } else {
        res = yield call(hinhThucThiApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IHinhThucThiActionTypes): any {
    const res: IBaseRespone = yield call(hinhThucThiApi.Deletes, action.payload as IIdsRequest)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}